var BaseView = require('./facebook/access');
var FacebookImagesView = require('./facebook/images');

module.exports = BaseView.extend({
  scope: 'user_photos',
  apiCall: 'load/albums/facebook',

  thumbnailClickEvent: function (id) {
    this.openNewView('images', FacebookImagesView, { albumId: id });
  }
});
